export default __webpack_public_path__ + "static/media/russian.dc14ddaa.svg";